import { render, staticRenderFns } from "./Commenti.vue?vue&type=template&id=1d0dc6f6"
import script from "./Commenti.vue?vue&type=script&lang=js"
export * from "./Commenti.vue?vue&type=script&lang=js"
import style0 from "./Commenti.vue?vue&type=style&index=0&id=1d0dc6f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports